module.exports = require('stream');



//////////////////
// WEBPACK FOOTER
// ../node_modules/readable-stream/lib/internal/streams/stream.js
// module id = ../node_modules/readable-stream/lib/internal/streams/stream.js
// module chunks = 5